import { Box, Button, Center, Grid, Heading, Image, Stack, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Card } from '../Card';
import { PublicPageLayout } from '../PublicPageLayout';

export function NavigateTo500() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <PublicPageLayout>
      <Grid w="full" h="full" placeItems="center">
        <Card p="20" m={20} textAlign="center" borderWidth={2} borderColor={'red.400'} bgColor={'red.100'}>
          <Center mb={8}>
            <Image src="/images/error.gif" alt="Error Gif" w={'30%'} h={'auto'} />
          </Center>
          <Stack spacing={8} alignItems={'center'}>
            <Heading as="h2" size="md" p={2} textAlign="center">
              {t('errors:boundary.title')}
            </Heading>
            <Stack spacing="2" maxW="40ch">
              <Text size={'sm'}>{t('errors:boundary.description')}</Text>
            </Stack>
            <Box>
              <Button variant={'primary'} onClick={() => navigate(-1)}>
                {t('errors:boundary.back')}
              </Button>
            </Box>
          </Stack>
        </Card>
      </Grid>
    </PublicPageLayout>
  );
}
export default NavigateTo500;
